import React from "react"
import {
  View,
  Window,
  Text,
  Touchable,
  Image,
  Toggle,
  CardNavigation,
} from "react-ame-components"

export class PrivacidadeExample extends React.Component {
  state = {
    toggles: {
      toggle_sms: true,
      toggle_email: true,
      toggle_notification: true,
    },
  }

  handleToggle = (toggle_type, e) => {
    let toggles = { ...this.state.toggles }
    toggles[toggle_type] = e
    this.setState({ toggles })
  }
  render() {
    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginVertical="big">
          <View
            width="570px"
            backgroundColor="neutral-100"
            padding="small"
            borderRadius="small">
            <View justify="end">
              <Touchable onClick={() => alert("Fechar")}>
                <Image icon="close" />
              </Touchable>
            </View>
            <View
              marginTop="medium"
              direction="column">
              <Text
                fontWeight="bold"
                fontSize="small"
                lineHeight="large">
                Privacidade
              </Text>
              <View
                width="!00%"
                height="20px"
              />
              <Text
                fontWeight="bold"
                fontSize="nano"
                lineHeight="large">
                Gerencie o recebimento das novidades e promoções
              </Text>
            </View>
            <View marginTop="medium">
              <View
                direction="row"
                align="center"
                justify="between"
                marginTop="extra-small"
                paddingBottom="extra-small"
                borderBottomWidth="hairline"
                borderColor="neutral-500">
                <Image icon="chat-sms-outline" />
                <View
                  direction="column"
                  marginLeft="medium">
                  <Text
                    fontWeight="bold"
                    fontSize="nano"
                    lineHeight="large"
                    color="neutral-700">
                    Receber por SMS
                  </Text>
                  <Text
                    fontSize="nano"
                    lineHeight="large">
                    Receba novidades e promoções por SMS no seu celular
                  </Text>
                </View>
                <View width="auto">
                  <Toggle
                    checked={this.state.toggles.toggle_sms}
                    onChange={e => this.handleToggle("toggle_sms", e)}
                  />
                </View>
              </View>
              <View
                direction="row"
                align="center"
                justify="between"
                marginTop="extra-small"
                paddingBottom="extra-small"
                borderBottomWidth="hairline"
                borderColor="neutral-500">
                <Image
                  icon="chat-mail-outline"
                  width="33px"
                />
                <View
                  direction="column"
                  marginLeft="medium">
                  <Text
                    fontWeight="bold"
                    fontSize="nano"
                    lineHeight="large"
                    color="neutral-700">
                    Receber por Email
                  </Text>
                  <Text
                    fontSize="nano"
                    lineHeight="large">
                    Receba novidades e promoções no seu e-mail cadastrado na Ame
                  </Text>
                </View>
                <View width="auto">
                  <Toggle
                    checked={this.state.toggles.toggle_email}
                    onChange={e => this.handleToggle("toggle_email", e)}
                  />
                </View>
              </View>
              <View
                direction="row"
                align="center"
                justify="between"
                marginTop="extra-small"
                paddingBottom="extra-small"
                borderBottomWidth="hairline"
                borderColor="neutral-500">
                <Image
                  icon="bell-notification-outline"
                  width="33px"
                />
                <View
                  direction="column"
                  marginLeft="medium">
                  <Text
                    fontWeight="bold"
                    fontSize="nano"
                    lineHeight="large"
                    color="neutral-700">
                    Receber por notificação
                  </Text>
                  <Text
                    fontSize="nano"
                    lineHeight="large">
                    Receba novidades e promoções por notificação no seu celular
                  </Text>
                </View>
                <View width="auto">
                  <Toggle
                    checked={this.state.toggles.toggle_notification}
                    onChange={e => this.handleToggle("toggle_notification", e)}
                  />
                </View>
              </View>
            </View>
            <View marginTop="large">
              <CardNavigation
                title="Politica de privacidade"
                leftIcon="padlock-lock-outline"
                onClick={() => console.log('Card clicado"')}
              />
            </View>
            <View
              width="100%"
              height="80px"
            />
            <View
              direction="column"
              align="center">
              <Image
                icon="alert-outline"
                width="33px"
                colorIcon="red"
              />
              <View width="333px">
                <Text
                  fontSize="nano"
                  lineHeight="large"
                  color="neutral-700"
                  textAlign="center">
                  Ao desativar as novidades e promoções, você continua recebendo
                  notificações de transações e segurança, ok?
                </Text>
              </View>
            </View>
            <View
              display="flex"
              marginTop="big"
              width="100%"
              justify="center">
              <Touchable
                onClick={() =>
                  alert("Tem certeza que deseja excluir sua conta?")
                }>
                <Text
                  fontSize="extra-small"
                  lineHeight="regular"
                  fontWeight="bold"
                  textAlign="center"
                  color="negative-700">
                  Excluir minha conta
                </Text>
              </Touchable>
            </View>
          </View>
        </View>
      </Window>
    )
  }
}
